// apps/client/src/stores/notificationStore.ts
import { create } from 'zustand';

export interface AppNotification {
  id:        string;
  title:     string;
  message:   string;
  type:      'order' | 'shipment' | 'payment' | 'system';
  isRead:    boolean;
  orderId?:  string;
  createdAt: string;
}

interface NotificationState {
  notifications:      AppNotification[];
  unreadCount:        number;
  addNotification:    (n: AppNotification) => void;
  markAsRead:         (id: string) => void;
  markAllAsRead:      () => void;
  setNotifications:   (ns: AppNotification[]) => void;
  removeNotification: (id: string) => void;
}

export const useNotificationStore = create<NotificationState>()((set) => ({
  notifications: [],
  unreadCount:   0,

  addNotification: (n) =>
    set((s) => ({
      notifications: [n, ...s.notifications].slice(0, 50),
      unreadCount:   s.unreadCount + (n.isRead ? 0 : 1),
    })),

  markAsRead: (id) =>
    set((s) => {
      const updated = s.notifications.map((n) =>
        n.id === id ? { ...n, isRead: true } : n,
      );
      return {
        notifications: updated,
        unreadCount:   updated.filter((n) => !n.isRead).length,
      };
    }),

  markAllAsRead: () =>
    set((s) => ({
      notifications: s.notifications.map((n) => ({ ...n, isRead: true })),
      unreadCount:   0,
    })),

  setNotifications: (ns) =>
    set({
      notifications: ns,
      unreadCount:   ns.filter((n) => !n.isRead).length,
    }),

  removeNotification: (id) =>
    set((s) => {
      const updated = s.notifications.filter((n) => n.id !== id);
      return {
        notifications: updated,
        unreadCount:   updated.filter((n) => !n.isRead).length,
      };
    }),
}));

// Day 14 complete
